import { render, staticRenderFns } from "./CaseloadDoughnut.vue?vue&type=template&id=6a9ee020&scoped=true&"
import script from "./CaseloadDoughnut.vue?vue&type=script&lang=js&"
export * from "./CaseloadDoughnut.vue?vue&type=script&lang=js&"
import style0 from "./CaseloadDoughnut.vue?vue&type=style&index=0&id=6a9ee020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ee020",
  null
  
)

export default component.exports